<!-- BOM订单信息 -->
<template>
  <div class="information">
    <div class="information__title">
      <i class="information__linker"></i>
      BOM
    </div>
    <div class="information__container">
      <InformationList :list="list">
      </InformationList>
    </div>
  </div>
</template>

<script>
import InformationList from './list'

export default {
  props: {
    number: {
      type: Number,
      default: 0
    }
  },
  components: {
    InformationList
  },
  computed: {
    list() {
      return [
        {
          width: '165px',
          children: [{ label: '采购数量', value: `${this.number}套` }]
        },
        {
          width: '303px',
          children: [{ label: '采购方式', value: '华秋人工代采' }]
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@@/styles/mixin.scss';
.information {
  display: flex;
  padding: 0 15px 12px;

  .information__title {
    flex-shrink: 0;
    position: relative;
    box-sizing: border-box;
    margin-right: 5px;
    width: 40px;
    height: 40px;
    line-height: 38px;
    text-align: center;
    font-weight: 700;
    color: #E6A23C;
    border-radius: $--border-radius-base;
    border: 1px solid #E6A23C;
    background-color: #FEF5E4;
    .information__linker {
      @include moduleLinkerMixin(22px, horizontal, dark);
      position: absolute;
      top: -4px;
      right: -4px;
    }
  }
  .information__container {
    width: 100%;
    ::v-deep .information-list {
      padding-top: 14px;
    }
  }
}
</style>